import { c as _c } from "react/compiler-runtime";
import { VillaSearchSummaryPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary.types";
import { dateFormat, daysBetweenDates } from "@website/utils/date-format";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import toNumber from "lodash-es/toNumber";
import { useRouter } from "next/router";
const parseQueryToNumber = (query?: string) => {
  const convertedNumber = toNumber(query);
  return Number.isNaN(convertedNumber) ? 0 : convertedNumber;
};
export const useVillaSearchSummary = properties => {
  const $ = _c(25);
  const router = useRouter();
  const {
    searchType,
    seoPageTitle,
    cityTitle,
    dateFrom,
    dateTo,
    adults,
    children,
    noRooms
  } = properties;
  let t0;
  if ($[0] !== dateFrom || $[1] !== router.locale) {
    t0 = dateFormat(dateFrom, {
      locale: router.locale,
      template: "dd MMMM"
    });
    $[0] = dateFrom;
    $[1] = router.locale;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = t0 as string;
  let t2;
  if ($[3] !== dateTo || $[4] !== router.locale) {
    t2 = dateFormat(dateTo, {
      locale: router.locale,
      template: "dd MMMM"
    });
    $[3] = dateTo;
    $[4] = router.locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = t2 as string;
  let t4;
  if ($[6] !== adults || $[7] !== children || $[8] !== router.locale) {
    t4 = !isFilled(adults) && !isFilled(children) || (Number(adults) || 0) + (Number(children) || 0) === 0 ? undefined : numberConvert(parseQueryToNumber(adults) + parseQueryToNumber(children), {
      locale: router.locale
    });
    $[6] = adults;
    $[7] = children;
    $[8] = router.locale;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== noRooms || $[11] !== router.locale) {
    t5 = isFilled(noRooms) ? numberConvert(parseQueryToNumber(noRooms), {
      locale: router.locale
    }) : undefined;
    $[10] = noRooms;
    $[11] = router.locale;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== dateFrom || $[14] !== dateTo) {
    t6 = daysBetweenDates(dateFrom, dateTo);
    $[13] = dateFrom;
    $[14] = dateTo;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== cityTitle || $[17] !== searchType || $[18] !== seoPageTitle || $[19] !== t1 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = {
      searchType,
      cityTitle,
      seoPageTitle,
      dateFrom: t1,
      dateTo: t3,
      passengersCount: t4,
      roomsCount: t5,
      nightCount: t6
    };
    $[16] = cityTitle;
    $[17] = searchType;
    $[18] = seoPageTitle;
    $[19] = t1;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};